import { useRuntimeConfig } from '#imports'
import { type Ref, computed } from 'vue'

import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { useMasterPP } from '~/scopes/product/composables/useMasterPP/useMasterPP'

import translations from './useProductHeadTitle.translations'

export function useProductHeadTitle({
  productResponse,
}: {
  productResponse: Ref<GetProductResponse | undefined>
}) {
  const i18n = useI18n()
  const runtimeConfig = useRuntimeConfig()
  const { isMasterPPUrl } = useMasterPP()

  const title = computed(() => {
    if (!productResponse.value) {
      return ''
    }

    if (isMasterPPUrl.value) {
      return `${i18n(translations.masterProductPageTitle, { title: productResponse.value.titles.default })} | ${runtimeConfig.public.COMPANY_NAME}`
    }

    return `${i18n(translations.variantProductPageTitle, { title: productResponse.value.titles.raw })} | ${runtimeConfig.public.COMPANY_NAME}`
  })

  return { title }
}
